import { apiService } from "../../../../services/api/apiService";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { createDictionaryApiFactory } from "../../Dictionaries/api/dictionaryApiFactory";
import { ClaimRequestTypeFormDto, ClaimRequestTypeListItemDto } from "../types";

export function mapDictionaryState(data: any): ClaimRequestTypeListItemDto {    
    const deletedAt = (data as any).deletedDate ?? (data as any).dataBaixa ?? null;

    return {
        ...data,
        isActive: !deletedAt
    };
}

const BASE_URL = "/claimRequestTypes";
const claimRequestType = createDictionaryApiFactory("claimRequestTypes");

export const getClaimRequestTypes = async (body: PaginationFilterDto): Promise<Pagination<ClaimRequestTypeListItemDto>> => {
    const response = await apiService.post<PaginationFilterDto, Pagination<ClaimRequestTypeListItemDto>>(`${BASE_URL}/search`, body);
    return { ...response, items: response.items.map(mapDictionaryState) };
}

export const getClaimRequestTypeById = async (id: number): Promise<ClaimRequestTypeFormDto> => 
    await apiService.get<ClaimRequestTypeFormDto>(`${BASE_URL}/detail/${id}`);

export const createClaimRequestType = async (body: ClaimRequestTypeFormDto): Promise<void> => 
    await apiService.post<ClaimRequestTypeFormDto, void>(`${BASE_URL}/create`, body);

export const updateClaimRequestType = async (id: number, body: ClaimRequestTypeFormDto): Promise<void> => 
    await apiService.put<ClaimRequestTypeFormDto, void>(`${BASE_URL}/${id}`, body);

export const exportCsvClaimRequestType = claimRequestType.exportCsv;
export const getRequestTypesByClient = claimRequestType.getSelectOptions;
